/**
 * The original input panel's english translations
 */
export const ORIGINAL_INPUT_PANEL_EN = {
  originalInput: 'Sources / Input',
  changed: 'Changed',
  inputChangedMessage: 'Input has been changed, you can now regenerate!',
  originalPlaceholder: `\
Start typing...

ATTENTION: Only information inside the Cooking Pot will be processed and used. If you upload an audio file, only the information inside it will be used!

Provide at least 50 words of input and source material (notes, documents, audio files, press releases, ...) here.
The more information & context you provide, the better the result.`
}

/**
 * The original input panel's german translations
 */
export const ORIGINAL_INPUT_PANEL_DE = {
  originalInput: 'Quellen / Eingabe',
  changed: 'Geändert',
  inputChangedMessage: 'Eingabe geändert - jetzt kannst du neu generieren!',
  originalPlaceholder: `Beginnen Sie mit der Eingabe...

ACHTUNG: Nur die Informationen im Cooking Pot werden verarbeitet und verwendet. Wenn Sie eine Audiodatei hochladen, werden nur die darin enthaltenen Informationen verwendet!

Geben Sie hier mindestens 50 Wörter Input und Quellmaterial (Notizen, Dokumente, Audiodateien, Pressemitteilungen, ...) ein.
Je mehr Informationen und Kontext Sie angeben, desto besser das Ergebnis.`
}
